import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const MonitorsIncidentsPerRegion = () => {

    const monitorReport = true;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType="REGION" disaggregation = "validity"/>
        </>
    
  )
}

export default MonitorsIncidentsPerRegion